import React from 'react'
import Comingsoonpage from '../../../common/Comingsoon';

const ReservationsQuotes = () => {
  return (
    <div><Comingsoonpage /></div>
  )
}

export default ReservationsQuotes;